(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/quickplay-modal-main.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/quickplay-modal-main.js');
"use strict";


const {
  useState
} = React;
const {
  Currency: formatCurrency
} = svs.utils.format;
const {
  productIds,
  getDisplayName
} = svs.utils.products;
const {
  ReactButton: Button,
  ReactIcon: Icon
} = svs.ui;
const {
  getSystemPrice
} = svs.components.lbUi;
const {
  TableOfDrawEvents,
  TableOfRaceDetails,
  TableOfScoreEvents
} = svs.components.sport.quickplayModal;
const {
  NumberSelector
} = svs.components.lbUi.numberSelector;
const QuickplayModalMain = _ref => {
  let {
    branding,
    productId,
    systemCost,
    systemType,
    drawData,
    raceData,
    pixData,
    onPixError,
    isPixMix,
    productSizes
  } = _ref;
  const {
    refreshPix
  } = pixData || {};
  const isScoreEvent = productId === productIds.BOMBEN;
  const isDraws = productId !== productIds.RACING && !isScoreEvent;
  const isRacing = productId === productIds.RACING;
  const [selectedSize, setSelectedSystemCost] = useState(pixData && systemType ? pixData.systemCost : systemCost);
  const systemPrice = getSystemPrice(selectedSize, systemType, productId);
  const showPricePicker = productSizes && productSizes.length > 0;
  return React.createElement("div", {
    className: "quickplay-modal-main elevation-400"
  }, React.createElement("div", {
    className: "padding-2 no-text-selection"
  }, Boolean(showPricePicker) && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "align-center price-picker-header"
  }, "V\xE4lj belopp"), React.createElement(NumberSelector, {
    className: "quickplay-modal-number-selector",
    isStepOnly: true,
    maxValue: productSizes[productSizes.length - 1],
    minValue: productSizes[0],
    onValueChange: value => {
      setSelectedSystemCost(productSizes[value]);
      refreshPix({
        onError: onPixError,
        systemCost: productSizes[value]
      });
    },
    possibleValues: productSizes,
    size: 600,
    suffix: " kr",
    value: productSizes.indexOf(selectedSize)
  })), Boolean(!showPricePicker) && React.createElement("div", {
    className: "f-900 f-center notranslate"
  }, "".concat(formatCurrency(systemPrice), " kr"))), Boolean(isDraws) && React.createElement(TableOfDrawEvents, {
    branding: branding,
    drawData: drawData,
    pixData: pixData
  }), Boolean(isRacing) && React.createElement(TableOfRaceDetails, {
    pixData: pixData,
    raceData: raceData
  }), Boolean(isScoreEvent) && React.createElement(TableOfScoreEvents, {
    branding: branding,
    drawData: drawData,
    pixData: pixData
  }), React.createElement("div", {
    className: "padding-2"
  }, React.createElement(Button, {
    block: true,
    disabled: !refreshPix,
    inverted: productId !== productIds.MALTIPSET,
    onClick: () => {
      {
        if (isPixMix) {
          const event = {
            category: 'PIX-mixen',
            action: 'Generate row',
            opt_label: getDisplayName(productId)
          };
          svs.components.analytics.trackEvent(event);
        }
      }
      return refreshPix({
        onError: onPixError,
        systemCost: selectedSize
      });
    },
    size: 300,
    transparent: true
  }, React.createElement(Icon, {
    className: "margin-right-1",
    icon: "refresh-pix",
    size: 300
  }), "Generera ny PIX!")));
};
QuickplayModalMain.defaultProps = {
  drawData: null,
  isPixMix: false,
  pixData: null,
  raceData: null
};
setGlobal('svs.components.sport.quickplayModal', {
  QuickplayModalMain
});

 })(window);